module.exports = __webpack_public_path__ + "static/media/image_25.63fe7d8d.png";